import L from 'leaflet';

/**
 * Gets a point from the click event and adds a marker in that place on the layer.
 * Then calls the callback funtion to send the RPA to that point.
 *
 * @callback
 * @param {*} arg - The object argument.
 * @param {object} arg.event - The event fired after creating a the landing bearing.
 * @param {Function} arg.getCurrentMapState - A function that gets the current variables needed from the map component.
 */
const sendToPointCallback = ({ event, getCurrentMapState }) => {
  const { toPointActive, toPoint, sendToPointMarkerLayer } = getCurrentMapState();
  if (toPointActive) {
    sendToPointMarkerLayer.clearLayers();
    L.marker(event.latlng.wrap()).addTo(sendToPointMarkerLayer);
    toPoint(event.latlng.wrap());
  }
};

export default sendToPointCallback;
